var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "groups",
    filter: "url(#filter0_d_1683_3572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21 19.125C23.445 19.125 25.605 19.71 27.36 20.475C28.98 21.195 30 22.815 30 24.57V27H12V24.585C12 22.815 13.02 21.195 14.64 20.49C16.395 19.71 18.555 19.125 21 19.125ZM9 19.5C10.65 19.5 12 18.15 12 16.5C12 14.85 10.65 13.5 9 13.5C7.35 13.5 6 14.85 6 16.5C6 18.15 7.35 19.5 9 19.5ZM10.695 21.15C10.14 21.06 9.585 21 9 21C7.515 21 6.105 21.315 4.83 21.87C3.72 22.35 3 23.43 3 24.645V27H9.75V24.585C9.75 23.34 10.095 22.17 10.695 21.15ZM33 19.5C34.65 19.5 36 18.15 36 16.5C36 14.85 34.65 13.5 33 13.5C31.35 13.5 30 14.85 30 16.5C30 18.15 31.35 19.5 33 19.5ZM39 24.645C39 23.43 38.28 22.35 37.17 21.87C35.895 21.315 34.485 21 33 21C32.415 21 31.86 21.06 31.305 21.15C31.905 22.17 32.25 23.34 32.25 24.585V27H39V24.645ZM21 9C23.49 9 25.5 11.01 25.5 13.5C25.5 15.99 23.49 18 21 18C18.51 18 16.5 15.99 16.5 13.5C16.5 11.01 18.51 9 21 9Z",
    fill: "#9F2FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1683_3572",
    x: 0,
    y: -1,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1683_3572"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1683_3572",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.c3ab52ca90bfdf64dc8588e7dcdb7ec4.svg";
export { ForwardRef as ReactComponent };